import { render, staticRenderFns } from "./CourseAgreementsList.vue?vue&type=template&id=c1635860&scoped=true"
import script from "./CourseAgreementsList.vue?vue&type=script&lang=js"
export * from "./CourseAgreementsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1635860",
  null
  
)

export default component.exports